import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";

import BlackTextLogo from "./black-text-logo.svg";
import WhiteTextLogo from "./white-text-logo.svg";

export const StyledBlackTextLogo = styled(BlackTextLogo)``;

export const StyledWhiteTextLogo = styled(WhiteTextLogo)``;

export const StyledLogoLink = styled(BaseLink)``;
